import { OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { BehaviorSubject, finalize, Subject, takeUntil } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PagingResponse, Reviewer } from '../models/reviewer.model';
import { PageEvent } from '@angular/material/paginator';
import { OrgService, PAGE_SIZE } from '../org.service';
import { Sort } from '@angular/material/sort';
import { FormioAppConfig, FormioComponent, FormioLoader } from 'dp-formio';
import { Utils } from 'formiojs';
import { ViewFormDialog } from '../view-form/view-form.component';

@Component({
	selector: 'add-edit-org-item',
	templateUrl: 'add-edit-org-item.component.html',
	styleUrls: ['./add-edit-org-item.component.scss'],
})
export class AddEditOrgItem implements OnInit, OnDestroy {
	@ViewChild(FormioComponent) formComponent: FormioComponent;
	destroy$ = new Subject<void>();
	isLoadingResults = false;
	expandedFilter = false;
	dataSource = [];
	displayedColumns = [
		'name',
		'gender',
		'nationality',
		'residenceCountry',
		'residencePlace',
		'residenceCity',
		'workDestination',
		'generalSpecialty',
		'reviewerState',
		'details',
		'actions'
	];

	pageSize = PAGE_SIZE;
	selectedPage = 0;
	totalItems = 0;
	dataSource$ = new BehaviorSubject<PagingResponse<Reviewer>>(null);
	selectedRow: Reviewer = null;
	filterQuery: any = {};
	details = false;

	roles = {
		'teamLeader': 'Team Leader',
		'spareTeamLeader': 'Spare Team Leader',
		'members': 'Members',
		'spareMembers': 'Spare Members',
		'observers': 'Observers',
		'spareObservers': 'Spare Observers',
		'traineeReviewers': 'Trainee Reviewers',
		'spareTraineeReviewer': 'Spare Trainee Reviewer'
	}

	constructor(public dialogRef: MatDialogRef<AddEditOrgItem>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialog: MatDialog,
		private loader: FormioLoader,
		private orgService: OrgService,
		private formioAppConfig: FormioAppConfig) {
	}
	ngOnInit(): void {
		this.loader.loading = false;
		if (!this.data.isFormio) {
			this.onSearch()
		}
	}
	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	selectRow(row: Reviewer) {
		if (this.details) {
			this.details = false;
			return;
		}
		this.selectedRow = row;
	}

	showDetails(event: any, row: Reviewer) {
		event.preventDefault();
		const model = Utils.evaluate(this.data.customOptions.profileResourceData, { config: this.formioAppConfig, ...row });
		this.details = true;

		this.dialog.open(ViewFormDialog, {
			data: {
				formKey: model.formKey,
				endpoint: model.endpoint,
				dir: this.data.dir,
			},
			width: '70%',
		});
	}

	sortData(event: Sort): void {
		this.filterQuery.sort = event.direction ? `${event.active},${event.direction}` : '';
		this.onSearch(this.filterQuery);
	}
	cancel() {
		this.dialogRef.close();
	}
	changePage(event: PageEvent) {
		this.pageSize = event.pageSize;
		this.selectedPage = event.pageIndex;
		this.onSearch(this.filterQuery);
	}

	searchWithReset(query = {}) {
		this.selectedPage = 0;
		this.onSearch(query);
	}

	onSearch(query = {}) {
		this.filterQuery = query;
		this.getData();
	}
	onClear() {
		this.searchWithReset();
	}

	customEvent(event: any) {
		if (event.component.key == 'cancel') this.dialogRef.close();
	}

	beforeSubmit(event: any) {
		this.dialogRef.close(event.data);
	}

	save() {
		this.data.submission.data.member = this.selectedRow;
		this.dialogRef.close(this.data.submission.data);
	}

	private getData() {
		this.isLoadingResults = true;
		const selectedIds = this.data.submission.data.selectedIds;
		const visitKey = this.data.submission.data.visitKey;

		let position = '';
		const role = this.data.submission.data.role.toLowerCase();
		if (role.includes('teamleader'))
			position = 'TEAMLEADER';
		else if (this.data.isMassar && role.includes('traineereviewer'))
			position = 'traineeReviewer';
		else if (role.includes('reviewer'))
			position = 'REVIEWER';
		else if (!this.data.isMassar && role.includes('observers'))
			position = 'OBSERVER';
		else
			position = 'REVIEWER';

		const data = {
			size: this.pageSize,
			page: this.selectedPage,
			...(selectedIds ? { 'id.notIn': selectedIds } : {}),
			'visitKey': visitKey,
			'position.equals': position,
			...this.filterQuery,
		};
		this.orgService
			.getReviewers(data, this.data.isMassar == true)
			.pipe(
				finalize(() => this.isLoadingResults = false),
				takeUntil(this.destroy$)
			)
			.subscribe((res) => {
				const item = res.data.find(q => q.id == this.data.submission.data.id);
				if (item) this.selectedRow = item;
				this.dataSource$.next(res);
			});
	}
}
